import { css, html } from 'react-strict-dom';
import { Api } from 'src/api';
import { Text } from 'src/components';
import { Style } from 'src/constants';
import { color } from 'src/constants/color.css';

import AvatarGroup from './AvatarGroup';

type Props = {
  memberUsers: Api.User.BaseView[];
};

export default function MembersCard({ memberUsers }: Props) {
  const clientMembers = memberUsers.filter((user) => user.agencyRole === null);
  const agencyMembers = memberUsers.filter((user) => user.agencyRole !== null);

  return (
    <html.div style={styles.card}>
      <html.div style={[Style.row, styles.columns]}>
        <html.div style={styles.column}>
          <Text typeface="body.regular" color="neutral80">
            Client
          </Text>
          <html.div style={[Style.row, Style.alignCenter]}>
            <AvatarGroup users={clientMembers} max={3} size={32} />
            {/* <Dropdown
              trigger={
                <IconButton>
                  <PlusIcon size={20} color={Color.neutral60} />
                </IconButton>
              }
              anchorSide="left"
            >
              <MemberSelectorDropdown
                ticket={ticket}
                allUsers={allUsers}
                kind="client"
                invalidate={invalidate}
              />
            </Dropdown> */}
          </html.div>
        </html.div>

        <html.div style={styles.column}>
          <Text typeface="body.regular" color="neutral80">
            M10c
          </Text>
          <html.div style={[Style.row, Style.alignCenter, styles.m10cRow]}>
            <AvatarGroup users={agencyMembers} max={3} size={32} />
            {/* <Dropdown
              trigger={
                <IconButton>
                  <PlusIcon size={20} color={Color.neutral60} />
                </IconButton>
              }
              anchorSide="right"
            >
              <MemberSelectorDropdown
                ticket={ticket}
                allUsers={allUsers}
                kind="agency"
                invalidate={invalidate}
              />
            </Dropdown> */}
          </html.div>
        </html.div>
      </html.div>
    </html.div>
  );
}

const styles = css.create({
  card: {
    backgroundColor: color.neutral0,
    borderRadius: 12,
    padding: 16,
    boxShadow: '0px 16px 16px rgba(0, 0, 0, 0.04)',
  },
  columns: {
    gap: 8,
  },
  column: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    minWidth: 0,
  },
  m10cRow: {
    justifyContent: 'space-between',
  },
});
